"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var core_1 = require("@emotion/core");

exports.IconTelescope1 = function (_a) {
  var _b = _a.weight,
      weight = _b === void 0 ? "normal" : _b,
      props = tslib_1.__rest(_a, ["weight"]);

  return core_1.jsx("svg", tslib_1.__assign({
    viewBox: "0 0 24 24",
    css: core_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      * {\n        vector-effect: non-scaling-stroke;\n      }\n      overflow: visible;\n      height: 24px;\n    "], ["\n      * {\n        vector-effect: non-scaling-stroke;\n      }\n      overflow: visible;\n      height: 24px;\n    "])))
  }, props), core_1.jsx("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }, core_1.jsx("path", {
    d: "M9.775 12.368l-4.17 2.095c-.973.49-2.16.097-2.649-.876l-.001-.002h0a1.973 1.973 0 0 1 .876-2.649l.002-.001 6.174-3.1 1.183 2.355M10.45 8.714a1.972 1.972 0 0 1 .876-2.649l.001-.001 6.175-3.1 2.659 5.292-5.112 2.568M.75 14.694l2.205-1.109M18.822 1.192l.882-.443h0l3.547 7.059h0l-.882.443a1.973 1.973 0 0 1-2.65-.877s0 0 0 0l-1.774-3.53a1.975 1.975 0 0 1 .877-2.652z"
  }), core_1.jsx("path", {
    d: "M15.43 11.4a3 3 0 1 1-5.356 2.7 3 3 0 0 1 5.354-2.701l.002.001zM12.75 15.75v7.5M6 23.25l4.591-8.417M19.5 23.25l-4.591-8.417"
  })));
};

var templateObject_1;